<template>
  <div>
    <SGPRowComponent>
      <div class="p-4">
        <h4 class="mb-4">Digite a designação e escolha o serviço</h4>
        <form @submit.prevent="submit()">
          <SGPFormInputComponent name="designacao" type="text" placeholder="Desig. (ex. CNL/IP/00000, 08009998888, 1921210000, CAS/IA/00022023)"
            v-model="formulario.designacao" @input="onDesignacaoInput" required />
          <br>
          <SGPFormInputComponent name="servico" type="text" placeholder="Serviço (ex. INTERNET, 0800 FASE1 DEDICADO, VIPLINE, LAN TO LAN)" v-model="formulario.servico"  />
          <br>
          <SGPFormInputComponent name="numeroOE" type="text" placeholder="Número da OE (preencha a OE caso o serviço for VIPLINE)" v-model="formulario.numeroOE" />
          <br>
          <SGPFormBotaoComponent type="submit" color="primary" block rounded middle>
            <span>Consultar</span>
          </SGPFormBotaoComponent>
        </form>
        <div v-if="loading">
          <pre> {{ mensagem }}</pre>
      </div>
        <!-- Display the retorno -->
        <div  v-if="retorno">
          <div class="saip-mensagem">
            <strong>Mensagem</strong><br>
            <pre> {{ retorno.mensagem }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.designacao !== null">
            <strong>Designação</strong><br>
            <pre> {{ retorno.designacao }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.numeroOTS !== null">
            <strong>Número OTS</strong><br>
            <pre> {{ retorno.numeroOTS }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.tipoOTS !== null">
            <strong>Tipo OTS</strong><br>
            <pre> {{ retorno.tipoOTS }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.roteador !== null">
            <strong>Roteador</strong><br>
            <pre> {{ retorno.roteador }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.porta !== null">
            <strong>Porta</strong><br>
            <pre> {{ retorno.porta }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.vlanCliente !== null">
            <strong>vLan Cliente</strong><br>
            <pre> {{ retorno.vlanCliente }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.vlanEmbratel !== null">
            <strong>vLan Embratel</strong><br>
            <pre> {{ retorno.vlanEmbratel }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.pe !== null">
            <strong>PE</strong><br>
            <pre> {{ retorno.pe }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.roteamento !== null">
            <strong>Roteamento</strong><br>
            <pre> {{ retorno.roteamento }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.multilink !== null">
            <strong>Multilink</strong><br>
            <pre> {{ retorno.multilink }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.blocosIPV4 !== null">
            <strong>Blocos IPV4</strong><br>
            <pre> {{ retorno.blocosIPV4 }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.dadosQOS !== null">
            <strong>Dados QOS</strong><br>
            <pre> {{ retorno.dadosQOS }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.observacoes !== null">
            <strong>Observações</strong><br>
            <pre> {{ retorno.observacoes }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.trocaDePE !== null">
            <strong>Troca de PE</strong><br>
            <pre> {{ retorno.trocaDePE }}</pre>
          </div>
          <div class="saip-dados" v-if="retorno.pePorta !== null">
            <strong> PE E Porta</strong><br>
            <pre> {{ retorno.pePorta }}</pre>
          </div>
          <div v-if="retornoConsultaEspelho.designacao !== null">
            <div class="saip-dados" v-if="retornoConsultaEspelho.designacao !== null">
              <strong>Designação do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.designacao }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.numeroOTS !== null">
              <strong>Número OTS do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.numeroOTS }}</pre>
            </div>
            <div class="saip-dados">
              <strong>Tipo OTS do Site Espelho </strong><br>
              <pre> {{ retornoConsultaEspelho.tipoOTS }}</pre>
            </div>
            <div class="saip-dados">
              <strong>Roteador do Site Espelho </strong><br>
              <pre> {{ retornoConsultaEspelho.roteador }}</pre>
            </div>
            <div class="saip-dados">
              <strong>Porta do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.porta }}</pre>
            </div>
            <div class="saip-dados">
              <strong>vLan Cliente do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.vlanCliente }}</pre>
            </div>
            <div class="saip-dados">
              <strong>vLan Embrateldo Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.vlanEmbratel }}</pre>
            </div>
            <div class="saip-dados">
              <strong>PE do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.pe }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.roteamento">
              <strong>Roteamento</strong><br>
              <pre> {{ retornoConsultaEspelho.roteamento }}</pre>
            </div>
            <div class="saip-dados">
              <strong>Multilink do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.multilink }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.blocosIPV4">
              <strong>Blocos IPV4 do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.blocosIPV4 }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.dadosQOS">
              <strong>Dados QOS do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.dadosQOS }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.observacoes">
              <strong>Observações do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.observacoes }}</pre>
            </div>
            <div class="saip-dados"
              v-if="retornoConsultaEspelho.trocaDePE !== null && retornoConsultaEspelho.trocaDePE !== ''">
              <strong>Troca de PE do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.trocaDePE }}</pre>
            </div>
            <div class="saip-dados" v-if="retornoConsultaEspelho.pePorta !== null && retornoConsultaEspelho.pePorta !== ''">
              <strong> PE E Porta do Site Espelho</strong><br>
              <pre> {{ retornoConsultaEspelho.pePorta }}</pre>
            </div>
            <div v-if="dados.descricaoPontaA !== null">
              <div class="saip-dados" v-if="dados.descricaoPontaA !== null">
                <strong>Descriação Ponta A</strong><br>
                <pre> {{ dados.descricaoPontaA }}</pre>
              </div>
              <div class="saip-dados" v-if="dados.descricaoPontaA !== null">
                <strong>Descriação Ponta A</strong><br>
                <pre> {{ dados.descricaoPontaA }}</pre>
              </div>
              <div class="saip-dados" v-if="dados.estacaoAcessoPontaA !== null"> 
                <strong> Estacao Acesso Ponta A </strong> <br>
                <pre> {{ dados.estacaoAcessoPontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.tipoAcessoPontaA !== null"> 
                <strong> Tipo Acesso PontaA </strong> <br>
                <pre> {{ dados.tipoAcessoPontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.roteadorPontaA !== null"> 
                <strong> Roteador Ponta A </strong> <br>
                <pre> {{ dados.roteadorPontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.tipoPortaPontaA !== null"> 
                <strong> Tipo Porta Ponta A </strong> <br>
                <pre> {{ dados.tipoPortaPontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.portaPontaA !== null"> 
                <strong> Porta Ponta A </strong> <br>
                <pre> {{ dados.portaPontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.vlanClientePontaA !== null"> 
                <strong> vlan Cliente Ponta A </strong> <br>
                <pre> {{ dados.vlanClientePontaA }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.descricaoPontaB !== null"> 
                <strong> Descricao Ponta B </strong> <br>
                <pre> {{ dados.descricaoPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.estacaoAcessoPontaB !== null"> 
                <strong> Estacao Acesso Ponta B </strong> <br>
                <pre> {{ dados.estacaoAcessoPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.tipoAcessoPontaB !== null"> 
                <strong> Tipo Acesso Ponta B </strong> <br>
                <pre> {{ dados.tipoAcessoPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.roteadorPontaB !== null"> 
                <strong> Roteador Ponta B </strong> <br>
                <pre> {{ dados.roteadorPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.tipoPortaPontaB !== null"> 
                <strong> Tipo Porta Ponta B </strong> <br>
                <pre> {{ dados.tipoPortaPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.portaPontaB !== null"> 
                <strong> Porta Ponta B </strong> <br>
                <pre> {{ dados.portaPontaB }} </pre>
              </div>
              <div class="saip-dados" v-if="dados.vlanClientePontaB !== null"> 
                <strong> vlan Cliente Ponta B </strong> <br>
                <pre> {{ dados.vlanClientePontaB }} </pre>
              </div>
            </div>
          </div>

        </div>
      </div>
    </SGPRowComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConsultaEquipamentoComponent',
  props:{
    value: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  data() {
    return {
      submitForm: false,
      formulario: {
        designacao: '',
        servico: '',
        numeroOE: ''
      },
      retorno: null,
      retornoConsulta: {
        designacao: null,
        numeroOTS: null,
        tipoOTS: null,
        roteador: null,
        porta: null,
        vlanCliente: null,
        vlanEmbratel: null,
        pe: null,
        roteamento: null,
        multilink: null,
        blocosIPV4: null,
        dadosQOS: null,
        observacoes: null,
        trocaDePE: null,
        pePorta: null

      },
      retornoConsultaEspelho: {
        designacao: null,
        numeroOTS: null,
        tipoOTS: null,
        roteador: null,
        porta: null,
        vlanCliente: null,
        vlanEmbratel: null,
        pe: null,
        roteamento: null,
        multilink: null,
        blocosIPV4: null,
        dadosQOS: null,
        observacoes: null,
        trocaDePE: null,
        pePorta: null

      },
    };
  },
  mounted() {
    if (this.value) {
      this.formulario.designacao = this.value.saip.toString();
      this.onDesignacaoInput();
    }
  },
  computed: {
    ...mapGetters('automacao', ['items'])
  },
  methods: {
    ...mapActions('automacao', ['listarSAIP']),
    onDesignacaoInput() {
      const upperCaseDesignacao = this.formulario.designacao.toUpperCase();
      this.formulario.designacao = upperCaseDesignacao;
      let servicoValue = '';

      if (upperCaseDesignacao.includes('/0800') || upperCaseDesignacao.includes('0800')) {
        servicoValue = '0800 FASE1 DEDICADO';
      } 
      else if (upperCaseDesignacao.includes('/IP/')) {
        servicoValue = 'INTERNET';
      }
      else if (upperCaseDesignacao.includes('/IA/')) {
        servicoValue = 'LAN TO LAN';
      }
      else if (/^\d+$/.test(upperCaseDesignacao)) {
        servicoValue = 'VIPLINE';
      }

      this.formulario.servico = servicoValue;
    },
    async submit() {
      this.submitForm = true;
      this.loading = true; // Start loading
      this.mensagem = 'Consultando dados...'; // Set initial message
      // Cria um objeto ParametrosEntradaDTO com os dados do formulário
      const payload = {
        designacao: this.formulario.designacao,
        servico: this.formulario.servico,
        numeroOE: this.formulario.numeroOE
      };

      try {
        let response = await this.listarSAIP([payload]); // Envia como um array com um único objeto

        if (response && response.data) {
          this.retorno = response.data;
          response.data[0].consultaGeraisDadosInternetDTO
          response.data[0].listaConsultaGeraisVozDTO

          this.retorno.map(dados => {
            dados.mensagem = dados.mensagem ?? '-'

            if (dados.consultaGeraisDadosInternetDTO) {
              dados.designacao = dados.consultaGeraisDadosInternetDTO.designacao
              dados.numeroOTS = dados.consultaGeraisDadosInternetDTO.numeroOTS
              dados.tipoOTS = dados.consultaGeraisDadosInternetDTO.tipoOTS
              dados.roteador = dados.consultaGeraisDadosInternetDTO.roteador
              dados.porta = dados.consultaGeraisDadosInternetDTO.porta
              dados.vlanCliente = dados.consultaGeraisDadosInternetDTO.vlanCliente
              dados.vlanEmbratel = dados.consultaGeraisDadosInternetDTO.vlanEmbratel
              dados.pe = dados.consultaGeraisDadosInternetDTO.pe
              dados.roteamento = dados.consultaGeraisDadosInternetDTO.roteamento
              dados.multilink = dados.consultaGeraisDadosInternetDTO.multilink
              dados.blocosIPV4 = dados.consultaGeraisDadosInternetDTO.blocosIPV4
              dados.dadosQOS = dados.consultaGeraisDadosInternetDTO.dadosQOS
              dados.observacoes = dados.consultaGeraisDadosInternetDTO.observacoes
              dados.trocaDePE = dados.consultaGeraisDadosInternetDTO.trocaDePE
              dados.pePorta = dados.consultaGeraisDadosInternetDTO.pePorta
            } else if (dados.listaConsultaGeraisVozDTO) {
              dados.designacao = dados.listaConsultaGeraisVozDTO[0].designacao
              dados.tipoOTS = dados.listaConsultaGeraisVozDTO[0].tipoOTS
              dados.roteador = dados.listaConsultaGeraisVozDTO[0].roteador
              dados.porta = dados.listaConsultaGeraisVozDTO[0].porta
              dados.vlanCliente = dados.listaConsultaGeraisVozDTO[0].vlanCliente
              dados.vlanEmbratel = dados.listaConsultaGeraisVozDTO[0].vlanEmbratel
              dados.pe = dados.listaConsultaGeraisVozDTO[0].pe
              dados.roteamento = dados.listaConsultaGeraisVozDTO[0].roteamento
              dados.multilink = dados.listaConsultaGeraisVozDTO[0].multilink
              dados.blocosIPV4 = dados.listaConsultaGeraisVozDTO[0].blocosIPV4
              dados.dadosQOS = dados.listaConsultaGeraisVozDTO[0].dadosQOS
              dados.observacoes = dados.listaConsultaGeraisVozDTO[0].observacoes
              dados.trocaDePE = dados.listaConsultaGeraisVozDTO[0].trocaDePE
              dados.pePorta = dados.listaConsultaGeraisVozDTO[0].pePorta
              if (typeof dados.listaConsultaGeraisVozDTO[1] != 'undefined') {
                this.retornoConsultaEspelho.designacao = dados.listaConsultaGeraisVozDTO[1].designacao
                this.retornoConsultaEspelho.designacao = dados.listaConsultaGeraisVozDTO[1].tipoOTS
                this.retornoConsultaEspelho.numeroOTS = dados.listaConsultaGeraisVozDTO[1].numeroOTS
                this.retornoConsultaEspelho.roteador = dados.listaConsultaGeraisVozDTO[1].roteador
                this.retornoConsultaEspelho.porta = dados.listaConsultaGeraisVozDTO[1].porta
                this.retornoConsultaEspelho.vlanCliente = dados.listaConsultaGeraisVozDTO[1].vlanCliente
                this.retornoConsultaEspelho.vlanEmbratel = dados.listaConsultaGeraisVozDTO[1].vlanEmbratel
                this.retornoConsultaEspelho.pe = dados.listaConsultaGeraisVozDTO[1].pe
                this.retornoConsultaEspelho.roteamento = dados.listaConsultaGeraisVozDTO[1].roteamento
                this.retornoConsultaEspelho.multilink = dados.listaConsultaGeraisVozDTO[1].multilink
                this.retornoConsultaEspelho.blocosIPV4 = dados.listaConsultaGeraisVozDTO[1].blocosIPV4
                this.retornoConsultaEspelho.dadosQOS = dados.listaConsultaGeraisVozDTO[1].dadosQOS
                this.retornoConsultaEspelho.observacoes = dados.listaConsultaGeraisVozDTO[1].observacoes
                this.retornoConsultaEspelho.trocaDePE = dados.listaConsultaGeraisVozDTO[1].trocaDePE
                this.retornoConsultaEspelho.pePorta = dados.listaConsultaGeraisVozDTO[1].pePorta
              }
            } else if (dados.consultaGeraisDadosLanToLanDTO) {
              dados.descricaoPontaA = dados.consultaGeraisDadosLanToLanDTO.descricaoPontaA
              dados.estacaoAcessoPontaA = dados.consultaGeraisDadosLanToLanDTO.estacaoAcessoPontaA
              dados.tipoAcessoPontaA = dados.consultaGeraisDadosLanToLanDTO.tipoAcessoPontaA
              dados.roteadorPontaA = dados.consultaGeraisDadosLanToLanDTO.roteadorPontaA
              dados.tipoPortaPontaA = dados.consultaGeraisDadosLanToLanDTO.tipoPortaPontaA
              dados.portaPontaA = dados.consultaGeraisDadosLanToLanDTO.portaPontaA
              dados.vlanClientePontaA = dados.consultaGeraisDadosLanToLanDTO.vlanClientePontaA
              dados.descricaoPontaB = dados.consultaGeraisDadosLanToLanDTO.descricaoPontaB
              dados.estacaoAcessoPontaB = dados.consultaGeraisDadosLanToLanDTO.estacaoAcessoPontaB
              dados.tipoAcessoPontaB = dados.consultaGeraisDadosLanToLanDTO.tipoAcessoPontaB
              dados.roteadorPontaB = dados.consultaGeraisDadosLanToLanDTO.roteadorPontaB
              dados.tipoPortaPontaB = dados.consultaGeraisDadosLanToLanDTO.tipoPortaPontaB
              dados.portaPontaB = dados.consultaGeraisDadosLanToLanDTO.portaPontaB
              dados.vlanClientePontaB = dados.consultaGeraisDadosLanToLanDTO.vlanClientePontaB

            }
          });
          this.retorno = this.retorno[0];
        } else {
          console.error('Erro ao obter dados:', response);
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
      } finally {
        this.submitForm = false;
        this.loading = false;
      }
    }
  }
};
</script>

<style>

.saip-mensagem {
  float: left;
  margin-bottom: 10px;
  width: 100%
}

.saip-mensagem pre {
  white-space: pre-wrap; /* Ensure line breaks and white space are respected */
  word-wrap: break-word; /* Handle long words or URLs that might break the layout */
  margin: 0; /* Remove default margin from <pre> */
  padding: 0; /* Remove default padding from <pre> */
}

.saip-geral {
  padding-top: 15px;
  margin-left: 10px;
}

.saip-dados {
  float: left;
  margin-bottom: 10px;
  width: calc(50% - 10px);
}
</style>